// 路由守卫

import router from '@/router'
import { Message } from 'element-ui';
/*
router.beforeEach((to,from,next) => {
  //本地存储拿到token
  let token = localStorage.getItem('access_token');
  let certification = JSON.parse(localStorage.getItem('certification'))
  // 可以看资讯动态+帮助
  const needToken = [
    '/dynamic/relationWe','/help/problem',
  ]
  //可以看所有 else
  const needCertificate = [
    '/scientificResearch/picture','/scientificResearch/video',
    '/resourceBase/germplasm/seed', '/resourceBase/germplasm/dna',
    '/resourceBase/germplasm/driedLeaf', '/resourceBase/germplasm/germplasmAnimal',
    '/resourceBase/dnaBar/spineAnimal', '/resourceBase/dnaBar/vascularPlant',
    '/resourceBase/list/protectList', '/resourceBase/list/uniqueList',
    '/resourceBase/workGuide/management', '/resourceBase/workGuide/filling',
      '/resourceBase/list/protectedWildPlants'
  ]
  const notLogin = [
    '/','/login','register'
  ]
  //
  const nextRouter = ['/dynamic/information','/dynamic/progressWork','/dynamic/standardSpecification','/dynamic/helpDocuments',
    '/help/problem','/help/relationWe','/scientificResearch/picture',
    '/scientificResearch/video','/resourceBase/germplasm/seed',
    '/resourceBase/germplasm/dna','/resourceBase/germplasm/driedLeaf',
    '/resourceBase/germplasm/germplasmAnimal','/resourceBase/dnaBar/spineAnimal',
    '/resourceBase/dnaBar/vascularPlant','/resourceBase/list/protectList',
    '/resourceBase/list/uniqueList','/resourceBase/workGuide/management',
    '/resourceBase/workGuide/filling','/resourceBase/list/protectedWildPlants']
  const toPath = to.path
  //未登录状态，当路由到nextRouter指定页面，跳转到login
  if(nextRouter.indexOf(toPath) >=0){
    //要去动态资讯但是没登录就去登录
    if(!token) {
      Message.error('你还未登录，请先登录！')
      next('/login')
    }
  }
  if(to.path === '/login'){
    //已经在登录页并且已经有token就可以去首页
    if(token){
      Message.success('你已经登录成功！')
      router.push('/')
      location.reload()
    }
  }
  if(needCertificate.indexOf(toPath) >=0){
    //要去资源库和科考视频
    if((certification === '2') && token ) {
      next()
    }else if((certification === '2') && !token) {
      next('/login')
    } else if((certification !== '2') && token) {
      Message({type:'error', message:'你无权查看该内容，请完成实名认证后查看'})
      next('/userinfo')
    }
  }
  next()
})
*/
router.beforeEach((to,from,next) => {
    next()
})
router.afterEach((to) => {
  document.title = to.meta.title
})
export default  router

